import React, { useContext, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import { OverrideBackground } from '../Unit/index';
import Title from '../Unit/Title';
import Sidebar from '../Unit/Sidebar';
import { AuthContext } from '../../../../context/AuthProvider';
import ArticleComponent from './Article';
import { useArticlesQuery } from '../../../../generated/graphqlModels';
import { useMutation, useQuery } from '@apollo/client';
import { CREATE_ARTICLE_READ, GET_ARTICLE_READS } from './queries';
import { HStack, VStack } from '@chakra-ui/react';

const ArticlePageUnstyled = (props: any) => {
  const context = useContext(AuthContext);
  const iframeRef = useRef(null);
  const { id } = useParams<{ id: string }>();
  const [state, setState] = useState({ name: '' });

  const { data, loading } = useArticlesQuery();
  const { data: articleReadsData, refetch: refetchArticleReads } = useQuery(
    GET_ARTICLE_READS,
    {
      variables: { userId: context?.pk },
    },
  );
  const [createArticleRead] = useMutation(CREATE_ARTICLE_READ);

  useEffect(() => {
    if (context?.pk && id) {
      createArticleRead({
        variables: {
          articleId: id,
        },
      })
        .then(() => {
          refetchArticleReads();
        })
        .catch((e) => console.log(e));
    }
  }, [id, context]);

  const article = data?.articles.find((a) => a.id === id);
  const filteredArticles =
    data?.articles.filter((a) => a.type === article?.type) || [];

  if (!id) return null;

  return (
    <>
      <OverrideBackground />
      <Title
        route={'/?tab=1'}
        buttonText="Back"
        unitName={state.name}
        isUnitLoading={false}
        isSaveAvailable={false}
      />
      <VStack
        className={props.className}
        justify="flex-start"
        align="start"
        h="full"
        p={0}
        position="relative"
      >
        <HStack
          w="full"
          overflow="unset !important"
          mt={8}
          spacing={0}
          align="start"
        >
          <Sidebar
            unit={
              {
                modules: filteredArticles.map((a) => ({
                  ...a,
                  contents: [{ ...a }],
                })),
              } as any
            }
            module={article}
            content={article}
            studyGroup={{}}
            context={context}
            handleOpenModal={() => {}}
            chalkups={
              articleReadsData?.articleReads?.map((a: any) => ({
                pk: a.articleId,
                content: { pk: a.articleId },
              })) || []
            }
            getRoute={((_s: any, id: string) => `/article/${id}/`) as any}
            isModuleLoading={false}
            isSaveAvailable={false}
          />
          <VStack
            minW={['100%', '100%', 'auto']}
            display="flex"
            flexGrow={1}
            flexShrink={1}
            flexBasis="70%"
          >
            <ArticleComponent
              ref={iframeRef}
              articleId={id}
              context={context as any}
              updateParentState={(newState) => {
                setState({ ...state, ...newState });
              }}
            />
          </VStack>
        </HStack>
      </VStack>
    </>
  );
};

export default ArticlePageUnstyled;
